<template>
  <section
    class="warning-popup-wrapper"
    :class="[
      displayLayout,
      layoutVersion,
      displayHorizontal ? 'horizontal' : '',
    ]"
  >
    <template v-if="type === 'popup'">
      <CommonPopup
        :showPopup="show"
        className="warning-popup"
        :title="title"
        :desc="desc"
        round
        :comfirmText="$t('accountAppeal.appeal_now')"
        :position="displayHorizontal ? 'center' : 'bottom'"
        :onlyOneButton="true"
        @confirm="jumpToAppeal"
        @closePopup="closePopup"
        parentContainer=".warning-popup-wrapper"
      />
    </template>
    <template v-else>
      <van-dialog
        :class="['warning-dialog', displayLayout]"
        v-model="show"
        :title="title"
        :message="desc"
        :message-align="textAlign"
        :confirm-button-text="$t('account.confirm')"
        getContainer="body"
      />
    </template>
  </section>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import CommonPopup from '@/components/CommonPopup'
  import bus from '@/utils/bus'
  import { isMsaWebView, msaJsFunc } from '@/utils/msa.js'
  import { jsontoString } from '@/utils/tool.js'

  export default {
    components: {
      CommonPopup,
    },
    props: {
      errCode: {
        type: String,
        default: '',
      },
      textAlign: {
        type: String,
        default: 'left', // 可选 left，right，center
      },
    },
    data() {
      return {
        show: false,
        type: '',
        desc: '',
      }
    },
    computed: {
      ...mapState(['layoutVersion']),
      ...mapGetters(['displayLayout', 'displayHorizontal']),
      title() {
        return this.$t('account.security_risk_alert')
      },
      typeMap() {
        return {
          1207: 'dialog',
          1208: 'popup',
        }
      },
      descMap() {
        return {
          1207: this.$t('apiErrorTips.1207'),
          1208: this.$t('apiErrorTips.1208'),
        }
      },
    },
    mounted() {
      bus.$on('account-risk', this.handler)
    },
    beforeDestroy() {
      bus.$off('account-risk')
    },
    methods: {
      handler(data) {
        const { typeMap, descMap } = this
        const { errCode } = data
        this.type = typeMap[errCode]
        this.desc = descMap[errCode]
        this.show = true
      },
      jumpToAppeal() {
        let query = this.$route.query
        query = {
          ...query,
          type: 'risk',
        }
        if (isMsaWebView()) {
          query.from = 'msa'
          const url =
            window.location.origin + '/account-appeal?' + jsontoString(query)
          msaJsFunc('callBrowser', url)
        } else {
          this.$router_push({
            path: '/account-appeal',
            query,
          })
        }
      },
      closePopup() {
        this.show = false
      },
    },
  }
</script>
<style scoped lang="scss">
  .warning-popup-wrapper {
    color: #000;
    ::v-deep .warning-popup.van-popup {
      &.desktop-layout,
      &.version-2 {
        background: $gray-popup;
        .title {
          color: #fff;
        }
        .desc {
          color: $white-4;
        }
      }
    }
    &.horizontal {
      ::v-deep .van-popup {
        max-width: px2vh(1080);
        min-width: px2vh(980);
        padding: px2vh(90) px2vh(75);
        .title {
          font-size: px2vh(50);
          line-height: px2vh(59);
          margin-bottom: px2vh(50);
        }
        .desc {
          font-size: px2vh(48);
          line-height: px2vh(70);
          margin-bottom: px2vh(75);
        }
        .btn-wrapper {
          button {
            min-width: px2vh(445);
            padding: px2vh(20) px2vh(60);
            height: px2vh(120);
            font-size: px2vh(48);
            line-height: px2vh(64);
            border-radius: px2vh(66);

            &.border-btn {
              border-width: px2vh(4);
            }
          }
        }
      }

      ::v-deep .van-dialog {
        width: auto;
        max-width: px2vh(980);
        min-width: px2vh(690);
        font-size: px2vh(52);
        border-radius: px2vh(30);
        .van-dialog__header {
          padding-top: px2vh(60);
          font-weight: 500;
          line-height: 1.2;
          text-align: center;
        }
        .van-dialog__content {
          .van-dialog__message {
            padding: px2vh(30) px2vh(60);
          }
          .van-dialog__message--has-title {
            font-size: px2vh(44);
            line-height: px2vh(48);
          }
        }

        .van-dialog__footer {
          .van-button {
            font-size: px2vh(52);
          }
          .van-dialog__confirm {
            height: px2vh(120);
          }
        }
      }
    }
  }

  .warning-dialog.desktop-layout {
    background: $gray-popup;
    font-family: Roboto;
    width: 400px;
    ::v-deep {
      .van-dialog__header {
        font-size: 20px;
        line-height: 24px;
        color: rgba(255, 255, 255, 0.9);
      }
      .van-dialog__content {
        .van-dialog__message--has-title {
          font-size: 16px;
          line-height: 20px;
          color: rgba(255, 255, 255, 0.6);
        }
      }
      .van-dialog__footer {
        .van-button--default {
          background: $gray-popup;
        }
        .van-button__text {
          color: #f96000;
          font-weight: bold;
        }
      }
      .van-hairline--top:after {
        border-color: rgba(255, 255, 255, 0.4);
      }
    }
  }
</style>
